import type { ReevaluateAPInvoiceExceptionsResult } from '@erp/rpc';

export type InvoiceExceptionsMenuState = {
  show: boolean;
  showTest: boolean;
  showReevaluate: boolean;
};

/** Which items the slide-in header menu should render. */
export function invoiceExceptionsMenuState(params: {
  invoiceLoaded: boolean;
  permissionsLoading: boolean;
  canTest: boolean;
  canReevaluate: boolean;
  isReevaluable: boolean;
}): InvoiceExceptionsMenuState {
  const showTest = params.canTest;
  const showReevaluate = params.canReevaluate && params.isReevaluable;
  return {
    show:
      params.invoiceLoaded &&
      !params.permissionsLoading &&
      (showTest || showReevaluate),
    showTest,
    showReevaluate,
  };
}

export type LiveReevaluateOutcome =
  | { kind: 'idle' }
  | { kind: 'running' }
  | { kind: 'error'; message: string }
  | {
      kind: 'success';
      openCount: number;
      openedCount: number;
      resolvedCount: number;
    };

/** Map one invoice's re-evaluate RPC row to dialog state. */
export function liveReevaluateOutcomeFromResult(
  result: ReevaluateAPInvoiceExceptionsResult | undefined,
): Extract<LiveReevaluateOutcome, { kind: 'error' | 'success' }> | null {
  if (!result) return null;
  if (!result.success) {
    return { kind: 'error', message: result.error ?? 'Re-evaluate failed' };
  }
  return {
    kind: 'success',
    openCount: result.openCount ?? 0,
    openedCount: result.openedCount ?? 0,
    resolvedCount: result.resolvedCount ?? 0,
  };
}
